
import { TableConfig, DataTable } from "@app/interfaces";

export class SurveyListTableConfig implements DataTable {

    constructor() { }

    static configure(): TableConfig {

        const tableConfig: TableConfig = {
            key: 'items',
            searchPanel: true,
            groupPanel: false,
            canEdit: true,
            showPagination: {
                showPageSizeSelector: true,
                pageSize: 10,
                allowedPageSizes: [10, 25, 50, 100]
            },
            fields: [
                {
                    caption: 'Name',
                    dataField: 'name'
                },
                // {
                //     caption: 'Created At',
                //     dataType: "datetime",
                //     format: "dd MMM, yyyy",
                //     dataField: 'updatedAt'
                // },
                {
                    caption: 'Clone',
                    width: 60,
                    cellTemplate: {
                        id: 'copy',
                        buttons: [{
                            icon: 'fa-solid fa-copy',
                            name: "Copy",
                            eventName: "copy",
                            cssClass: "me-2"
                        }],
                    },
                },
                {
                    caption: 'Details',
                    width: 60,
                    cellTemplate: {
                        id: 'details',
                        buttons: [{
                            icon: 'fa-solid fa-arrow-right',
                            name: "Details",
                            eventName: "details",
                            cssClass: "me-2"
                        }],
                    },
                },
            ]
        };

        return tableConfig;

    }

}